import { XHRInstance } from "@sembark-travel/xhr"
import { ILocation } from "../Locations"
import { IUser } from "../Auth"
import { IAddress } from "../Addresses"

export type TInvoice = {
	id: number
	overview?: string
	status: "draft" | "new" | "processed"
	number?: string
	reference_id?: string
	due_at: string
	created_at: string
	currency: string
	total_amount: number
	seller_name: string
	seller_address?: IAddress
	seller_functional_currency: string
	buyer_name: string
	buyer_address?: IAddress
	location_of_supply?: ILocation
	created_by: IUser
	updated_at?: string
	updated_by: IUser
	items: Array<{
		description: string
		currency: string
		quantity: number
		rate_per_quantity: number
		total_taxable_amount: number
		tax_applied_on_base_amount?: 0 | 1
		taxes: Array<{
			name: string
			short_name: string
			percentage: number
			amount?: number
			editing_amount?: 0 | 1
		}>
	}>
	pdf_file_url?: string
	is_generating_pdf?: boolean
	default_hsn: null | string
	display_hsn: boolean
	display_place_of_supply: boolean
}

/**
 * Configuration for dynamic filters that require API calls onChange to fetch new content/data from api
 */

export type TInvoiceFilterType =
	| "hide_itemized_breakup"
	| "display_line_items"
	| "display_price_breakup"
	| "display_price_breakup_with_tax"

export type TInvoiceFilter = {
	id: TInvoiceFilterType
	name: string
	included: 0 | 1
	disabled?: boolean
	options?: Array<{
		name: string
		included: 0 | 1
		disabled?: boolean
	}>
}

/**
 * Configuration for hardcoded filters that DO require API calls but are not provided in meta.options
 * These filters are managed on the frontend but their initial values come from API data usually from /create apis.
 */

export type TInvoiceCustomFilterType = "hide_tax_breakup"

export type TInvoiceCustomFilter = {
	id: TInvoiceCustomFilterType
	name: string
	included: 0 | 1
	onChange: (included: 0 | 1) => void
	disabled?: boolean
}

export function invoicesXHR(xhr: XHRInstance) {
	return {
		async destroy(invoiceId: number | string) {
			return xhr
				.delete<{ message: string }>(`/invoices/${invoiceId}`)
				.then((resp) => resp.data)
		},
		async getLocationsOfSupply(params: unknown) {
			return xhr
				.get<{ data: Array<ILocation> }>(`/invoices/locations-of-supply`, {
					params,
				})
				.then((resp) => resp.data.data)
		},
	}
}
